<div class="widget-panel">

  @if (hasWidget) {
    <div class="widget-panel__section">
      <div class="widget-panel__section-title">
        <mat-icon>widgets</mat-icon>
        {{ 'Widget Properties' | translate }}
      </div>
      @for (def of propertyDefs; track trackByKey($index, def)) {
        <div class="widget-panel__property">
          @switch (def.type) {
            @case (WidgetPropertyType.Boolean) {
              <label class="widget-panel__checkbox-label">
                <input type="checkbox" [(ngModel)]="localProperties[def.key]" (change)="onPropertyChange()" />
                {{ def.label | translate }}
              </label>
            }
            @case (WidgetPropertyType.String) {
              <div class="widget-panel__field-group">
                <label>{{ def.label | translate }}</label>
                <input type="text" class="widget-panel__input" [(ngModel)]="localProperties[def.key]"
                  (input)="onPropertyChange()" />
                </div>
              }
              @case (WidgetPropertyType.Number) {
                <div class="widget-panel__field-group">
                  <label>{{ def.label | translate }}</label>
                  <input type="number" class="widget-panel__input" [(ngModel)]="localProperties[def.key]"
                    (input)="onPropertyChange()" />
                  </div>
                }
              }
            </div>
          }
        </div>
      }

      @if (hasPrintOptions) {
        <div class="widget-panel__section">
          <div class="widget-panel__section-title">
            <mat-icon>print</mat-icon>
            {{ 'Print Options' | translate }}
          </div>
          @if (isRiskRegister) {
            <div class="widget-panel__field-group">
              <label>{{ 'Page Orientation' | translate }}</label>
              <select class="widget-panel__input" [(ngModel)]="localPrintOptions!.pageOrientation" (change)="onPrintOptionsChange()">
                <option value="landscape">{{ 'Landscape' | translate }}</option>
                <option value="portrait">{{ 'Portrait' | translate }}</option>
              </select>
            </div>
          }
          <div class="widget-panel__field-group">
            <label>{{ 'Margins' | translate }}</label>
            <select class="widget-panel__input" [(ngModel)]="localMarginsLabel" (change)="onMarginsLabelChange()">
              <option value="None">{{ 'None' | translate }}</option>
              <option value="Micro">{{ 'Micro' | translate }}</option>
              <option value="Small">{{ 'Small' | translate }}</option>
              <option value="Medium">{{ 'Medium' | translate }}</option>
              <option value="Large">{{ 'Large' | translate }}</option>
            </select>
          </div>
          <label class="widget-panel__checkbox-label">
            <input type="checkbox" [(ngModel)]="localPrintOptions!.showPageNumbers" (change)="onPrintOptionsChange()" />
            {{ 'Show Page Numbers' | translate }}
          </label>
          <label class="widget-panel__checkbox-label">
            <input type="checkbox" [(ngModel)]="localPrintOptions!.showGenerationDate" (change)="onPrintOptionsChange()" />
            {{ 'Show Generation Date' | translate }}
          </label>
          <div class="widget-panel__field-group">
            <label>{{ 'Watermark Text' | translate }}</label>
            <input type="text" class="widget-panel__input" [(ngModel)]="localPrintOptions!.watermarkText"
              (input)="onPrintOptionsChange()" [placeholder]="'Leave empty to disable' | translate" />
            </div>
            <div class="widget-panel__field-group">
              <label>{{ 'Header Text' | translate }}</label>
              <input type="text" class="widget-panel__input" [(ngModel)]="localPrintOptions!.headerText"
                (input)="onPrintOptionsChange()" [placeholder]="'Leave empty to disable' | translate" />
              </div>
              <div class="widget-panel__field-group">
                <label>{{ 'Footer Text' | translate }}</label>
                <input type="text" class="widget-panel__input" [(ngModel)]="localPrintOptions!.footerText"
                  (input)="onPrintOptionsChange()" [placeholder]="'Leave empty to disable' | translate" />
                </div>
              </div>
            }

            @if (!hasWidget && !hasPrintOptions) {
              <div class="widget-panel__empty">
                <mat-icon>touch_app</mat-icon>
                <span>{{ 'Click a widget in the template to see its properties' | translate }}</span>
              </div>
            }
          </div>
